var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", [
                _c("table", { staticClass: "table table-hover table-sm" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.records, function (record, i) {
                      return _c("tr", [
                        _c("td", [_vm._v(_vm._s(i + 1))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("p", [
                            _vm._v(
                              "(" +
                                _vm._s(record.id) +
                                ") " +
                                _vm._s(record.name)
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            _vm._l(record.roles, function (role) {
                              return _c("span", { staticClass: "badge mr-1" }, [
                                _vm._v(_vm._s(role.name_title)),
                              ])
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$AllCurrencies[
                                  record.sortedDetails.salary_details.details
                                    .base_currency
                                ].currency
                              ) +
                              ":\n              " +
                              _vm._s(
                                record.sortedDetails.salary_details.details
                                  .base_salary
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("p", [
                            _vm._v("заявки "),
                            _c("strong", [
                              _vm._v(
                                "RUB: " +
                                  _vm._s(
                                    Math.round(
                                      _vm.salaryData[record.id].orders_sum
                                    )
                                  )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("заявки "),
                            _c("strong", [
                              _vm._v(
                                "EUR: " +
                                  _vm._s(
                                    Math.round(
                                      _vm.salaryData[record.id].orders_sum_eur
                                    )
                                  )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("процента "),
                            _c("strong", [
                              _vm._v(
                                "EUR: " +
                                  _vm._s(
                                    Math.round(
                                      _vm.salaryData[record.id].calculated_rate
                                    )
                                  )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  Math.round(
                                    _vm.salaryData[record.id].prospect_eur
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$AllCurrencies[
                                        record.sortedDetails.salary_details
                                          .details.pay_currency_id
                                      ].currency
                                    ) +
                                    "\n                  "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.paymentSum[record.id].sum,
                                  expression: "paymentSum[record.id].sum",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.paymentSum[record.id].sum,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.paymentSum[record.id],
                                    "sum",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.paymentSum[record.id].comment,
                                expression: "paymentSum[record.id].comment",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Комментарий...",
                            },
                            domProps: {
                              value: _vm.paymentSum[record.id].comment,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.paymentSum[record.id],
                                  "comment",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("LoadingButton", {
                              attrs: {
                                title: "Выплатить",
                                loading: _vm.loadingBtn[record.id],
                                color: _vm.$constants.SUCCESS_COLOR,
                                onClick: () => _vm.makePayment(record),
                                className: "btn btn-outline-success",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Сотрудник")]),
        _vm._v(" "),
        _c("th", [_vm._v("Фиксированный")]),
        _vm._v(" "),
        _c("th", [_vm._v("Фактический")]),
        _vm._v(" "),
        _c("th", [_vm._v("Просчет")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }